import Vue from 'vue'
import pdf from 'vue-pdf'

Vue.component('VuePdf', pdf)

export default ({ app }, inject) => {
  inject('VuePdf', pdf)
}
